import { LoadingContainer } from '@tuhi/components'
import { fetchTuhiUser } from 'app/api/auth/repository/authenticationRepository'
import { retrieveCheckoutSessionSuccess } from 'app/api/subscriptions/stripeCheckoutRepository'
import { requireMsalAccessToken } from 'app/models/domain/auth'
import { RouteUrl } from 'app/routes'
import { selectAuthState } from 'app/store/selectors'
import { setTuhiUser } from 'app/store/slices/authSlice'
import { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'

const Loading = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
`

export const checkoutSuccessLoadingText =
    'Payment successful! Finalizing your subscription...'

export const CheckoutSuccess: FC = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { sessionId } = useParams()

    const { msalCredentials } = useSelector(selectAuthState)

    useEffect(() => {
        const updatePlan = async () => {
            // The route is `checkout/:sessionId`, so it is always set here.
            if (!sessionId) return

            let paymentCompleted =
                await retrieveCheckoutSessionSuccess(sessionId)

            if (paymentCompleted) {
                let tuhiUser = await fetchTuhiUser(
                    requireMsalAccessToken(msalCredentials)
                )
                dispatch(setTuhiUser(tuhiUser.toData()))

                navigate(RouteUrl.PlanManagement.path)
            }
        }

        updatePlan()
        // eslint-disable-next-line react-hooks/exhaustive-deps -- Runs once on landing: re-running when credentials refresh or navigate changes would re-check the payment and redirect again
    }, [dispatch])

    return (
        <Loading>
            <LoadingContainer
                text={checkoutSuccessLoadingText}
                isLoading={true}
            />
        </Loading>
    )
}
